export default "__VITE_ASSET__Q__dyAs6__"